import { Star } from "lucide-react";
import { SITE } from "../data/site";
import { useLang } from "../context/LanguageContext";

export function GoogleBadge({ dark = false }) {
  const { t } = useLang();
  return (
    <a
      href={SITE.googleBusiness}
      target="_blank"
      rel="noreferrer"
      data-testid="google-business-badge"
      className={`inline-flex items-center gap-3 rounded-full pl-3 pr-5 py-2 transition-transform hover:scale-[1.03] ${
        dark ? "bg-white/15 text-white backdrop-blur-md" : "bg-white shadow-md text-brand-gray"
      }`}
    >
      <span className="font-heading font-bold text-lg" style={{ color: "#4285F4" }}>G</span>
      <div className="flex flex-col leading-tight text-left">
        <span className="flex items-center gap-0.5">
          {[1, 2, 3, 4, 5].map((i) => (
            <Star key={i} size={14} className="fill-yellow-400 text-yellow-400" />
          ))}
          <span className="ml-1 font-bold text-sm">5.0</span>
        </span>
        <span className={`text-xs ${dark ? "text-white/80" : "text-slate-500"}`}>
          {SITE.yearsInBusiness} {t.google.years} • {t.google.reviews}
        </span>
      </div>
    </a>
  );
}

export default GoogleBadge;
